import { BaseComponent } from '../base-component'
import { debounce } from '../../utils/debounce'
import { $el } from 'src/scripts/utils/utils'

const LINE_CLAMP_SELECTOR = '[data-quote-line-clamp]'
const TARGET_SELECTOR = '[data-quote-line-clamp-target]'

export class MaxLinesComponent extends BaseComponent {
  resizeObserver: ResizeObserver

  mountComponent() {
    this.resizeObserver = new ResizeObserver(this.handleResize)
    this.resizeObserver.observe(this)
  }

  unmountComponent(): void {
    this.resizeObserver.disconnect()
  }

  handleResize = debounce((): void => {
    this.update()
  }, 100)

  update(): void {
    const lineClamp = $el(LINE_CLAMP_SELECTOR, this)
    const target = $el(TARGET_SELECTOR, this)

    if (!lineClamp || !target) {
      return
    }

    const heightContainer = $el('[data-quote-height]', this)
    const styles = getComputedStyle(target)

    const lineHeight = parseFloat(styles['lineHeight'])
    const height = lineClamp.offsetHeight
    const containerHeight = heightContainer?.offsetHeight ?? height
    const diff = (containerHeight - height) / lineHeight
    let maxLines = Math.floor(height / lineHeight)

    if (diff > 2) {
      maxLines = Math.floor(containerHeight / lineHeight)
      lineClamp.style.maxHeight = `${containerHeight}px`
    }

    target.style['-webkit-line-clamp'] = maxLines
    target.style.height = `${maxLines * lineHeight}px`

    this.setAttribute('data-line-clamp-setter-is-ready', '')

    this.emit('linesSetted', { target })
  }
}
